import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesDataSimpleGrid } from './SimpleGrid.proptypes';

import * as S from './SimpleGrid.styles';

const renderStars = stars => {
  const numStars = parseInt(stars, 10);
  if (isNaN(numStars)) {
    return null;
  }

  return Array.from({ length: numStars }, (_, index) => (
    <S.Star key={index} role='img' aria-label='star'>
      ⭐️
    </S.Star>
  ));
};

export const SimpleGridSlice = ({ slice }) => {
  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const { simple_grid_slice_id: id } = data || '';
  const items = slice.items;

  if (items?.length < 2) {
    Sentry.captureMessage('Error: missing required data in SimpleGrid slice');
    return null;
  }

  return (
    <S.Wrapper id={id}>
      <S.StyledRow>
        {items.map((item, index) => {
          const title = item.column_title || '';

          return <S.StyledTitle key={index}>{title}</S.StyledTitle>;
        })}
      </S.StyledRow>
      <S.StyledRow>
        {items.map((item, index) => {
          const headLine = item.headline_content || '';
          const content = item.content || '';
          const stars = item.stars || '';
          const isMaximum = stars === '5';

          return (
            <S.Content isMaximum={isMaximum} key={index}>
              {stars ? (
                <>{renderStars(stars)}</>
              ) : (
                <S.TextWrapper>
                  {headLine && <S.Label>{headLine}</S.Label>}
                  {content && <S.Description>{content}</S.Description>}
                </S.TextWrapper>
              )}
            </S.Content>
          );
        })}
      </S.StyledRow>
    </S.Wrapper>
  );
};

SimpleGridSlice.propTypes = {
  /**
   * Content of the SimpleGrid slice.
   */
  slice: PropTypes.shape(propTypesDataSimpleGrid),
};
